import {Slider} from '@fantasmagames/slot/src/display/Slider/Slider';
import {GameUtils} from '@fantasmagames/slot/src/utils/GameUtils';

export class SnappingSlider extends Slider {
	public updateValues(values: number[], defaultValueIndex: number = -1): void {
		this._values = values;
		const length = values.length - 2;
		this._defaultValueIndex = defaultValueIndex;
		this._slots = [0];

		for (let i = 1; i <= length; i++) {
			this._slots.push(Math.floor((i / (this._values.length - 1)) * 100));
		}

		this._slots.push(100);
	}

	protected onDragEnd(): void {
		this._touchEvent = null;
		this._dragging = false;

		// const percentage = this.calcProcentage(this._dragger.position.x) / 100;
		const percentage = this._slots[this._values.indexOf(this.currentValue)] / 100;
		this._dragger.position.x = this.calcSliderPosition(percentage);
	}

	protected calcSliderPosition(percentage: number): number {
		const max = this._sliderHalfWidth - this._draggerHalfWidth;
		const min = this._startX + this._draggerHalfWidth;

		const position = GameUtils.lerp(min, max, percentage);

		return position;
	}

	protected onDragMove(): void {
		// TODO: Snap during drag?
		if (this._dragging) {
			if (!this._touchEvent) {
				return;
			}
			const newPosition = this._touchEvent.getLocalPosition(this._dragger.parent);

			if (newPosition.x - this._draggerHalfWidth < this._startX) {
				this._dragger.position.x = this._startX + this._draggerHalfWidth;
				this.updateValue(this._values[0]);
			} else if (newPosition.x + this._draggerHalfWidth > this._sliderHalfWidth) {
				this._dragger.position.x = this._sliderHalfWidth - this._draggerHalfWidth;
				this.updateValue(this._values[this._values.length - 1]);
			} else {
				this._dragger.position.x = newPosition.x;
				const procentage: number = this.calcProcentage(newPosition.x);
				for (let i = 0; i < this._slots.length; i++) {
					if (procentage <= this._slots[i]) {
						this.updateValue(this._values[i]);
						break;
					}
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/display/Slider/SnappingSlider.ts